import { createFileRoute, redirect, stripSearchParams } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'
import { PilotageEcran } from './-ecran/pilotage-ecran'
import {
  PILOTAGE_SEARCH_DEFAULTS,
  pilotageSearchSchema,
  rechercheRedirigee,
} from './-search-schema'
import { PILOTAGE_READ } from './-shared/pilotage-permissions'

/**
 * Onglet « Pilotage » de la rubrique Prévisions : l'écran unique (prévision de la semaine,
 * projection casse / rupture, alertes). Un lien de l'ancienne vue Réappro (ou d'une modale de
 * tuile) est redirigé vers lui.
 */
export const Route = createFileRoute('/_authenticated/previsions-pilotage/')({
  component: PilotageEcran,
  staticData: { permission: PILOTAGE_READ },
  validateSearch: pilotageSearchSchema,
  search: { middlewares: [stripSearchParams(PILOTAGE_SEARCH_DEFAULTS)] },
  beforeLoad: ({ search }) => {
    const redirigee = rechercheRedirigee(search)
    if (redirigee !== null) {
      throw redirect({ to: '/previsions-pilotage', search: redirigee, replace: true })
    }
  },
})

withRoutePermissions(Route)
